import { PropOption } from "../../PropX";
import { getKeyPathFromSelection, Selection } from "./selection";
import { Suggestions, suggestionsToOptions } from "./suggestions";
import { toProgram } from "./toProgram";

export const findOptions = (source: string, selection: Selection, suggestions: Suggestions): PropOption[] => {
  const program = toProgram(source);
  const keyPath = getKeyPathFromSelection(program, selection);

  if (keyPath === null) {
    return [];
  }

  return suggestionsToOptions(suggestions, keyPath);
};
